import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFortnoxVoucherSeries = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}fortnox_voucher_series`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getFortnoxVoucherSeries